/**
 * w-drawer-menu.js
 * Mobile drawer menu - split click: text = navigate, chevron button = expand submenu.
 * Flattened parent panels: back from level 2 goes to main when parent has [mobile-flatten].
 */
class DrawerMenu extends HTMLElement {
  constructor() {
    super();

    this.openButton = document.querySelector(".open-drawer-menu");
    this.closeButton = this.querySelector(".drawer-menu__close");
    this.chevronButtons = this.querySelectorAll("button[data-open-mega-menu]");
    this.main_menu = this.querySelector(".drawer-menu__linklists");
    this.return_btn = this.querySelector(".drawer-menu__return");

    this.return_btn_collections = this.querySelectorAll("[data-drawer-return]");

    this.return_btn_collections.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        this.returnMenu(event).bind(this);
      });
    });

    this.openButton?.addEventListener("click", this.openMenu.bind(this));
    this.closeButton?.addEventListener("click", this.closeMenu.bind(this));

    this.chevronButtons.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggleMenu(btn);
      });
    });

    this.return_btn?.addEventListener("click", (event) => {
      this.returnMenu(event).bind(this);
    });
  }

  openMenu(e) {
    e.preventDefault();
    this.classList.add("open");
    document.querySelector("body").classList.add("shadow-drawer");
  }

  closeMenu() {
    this.classList.remove("open");
    document.querySelector("body").classList.remove("shadow-drawer");
  }

  toggleMenu(btn) {
    const menu = btn.getAttribute("data-open-mega-menu");
    const menuElement = this.querySelector(
      `.mega-menu__panel[data-mega-menu="${menu}"]`
    );
    const main_header = this.querySelector(".drawer-menu__header");
    main_header.classList.add("hidden");

    let panelThirdOpen =
      document.querySelectorAll(
        ".mega-menu__panel--third.mega-menu__panel--actif"
      ).length > 0;
    let panelSecondOpen =
      document.querySelectorAll(
        ".mega-menu__panel--second.mega-menu__panel--actif"
      ).length > 0;
    let panelFirstOpen =
      document.querySelectorAll(
        ".mega-menu__panel--first.mega-menu__panel--actif"
      ).length > 0;

    if (panelThirdOpen) {
      document
        .querySelectorAll(".mega-menu__panel--third.mega-menu__panel--actif")
        .forEach((panel) => {
          panel.classList.remove("mega-menu__panel--actif");
        });
    }

    if (panelSecondOpen) {
      document
        .querySelectorAll(".mega-menu__panel--second.mega-menu__panel--actif")
        .forEach((panel) => {
          panel.classList.remove("mega-menu__panel--actif");
        });
    }

    if (panelFirstOpen) {
      document
        .querySelector(".mega-menu__panel--first.mega-menu__panel--actif")
        .classList.remove("mega-menu__panel--actif");
    }

    this.main_menu.classList.add("hidden");
    menuElement.classList.add("mega-menu__panel--actif");
    this.return_btn?.classList.remove("hidden");
  }

  returnMenu(event) {
    event.preventDefault();
    const main_header = this.querySelector(".drawer-menu__header");
    const currentMenu = this.querySelector(".mega-menu__panel--actif");

    if (currentMenu.classList.contains("mega-menu__panel--third")) {
      currentMenu.classList.remove("mega-menu__panel--actif");
      const parentId = currentMenu.getAttribute("data-parent-menu");
      const parentPanel = this.querySelector(
        `.mega-menu__panel[data-mega-menu="${parentId}"]`
      );
      parentPanel.classList.add("mega-menu__panel--actif");
    } else if (currentMenu.classList.contains("mega-menu__panel--second")) {
      currentMenu.classList.remove("mega-menu__panel--actif");
      const parentId = currentMenu.getAttribute("data-parent-menu");
      const parentPanel = this.querySelector(
        `.mega-menu__panel[data-mega-menu="${parentId}"]`
      );
      if (parentPanel?.getAttribute("data-flattened-parent") === "true") {
        this.main_menu.classList.remove("hidden");
        main_header.classList.remove("hidden");
        this.return_btn?.classList.add("hidden");
      } else {
        parentPanel.classList.add("mega-menu__panel--actif");
      }
    } else {
      currentMenu.classList.remove("mega-menu__panel--actif");
      this.main_menu.classList.remove("hidden");
      main_header.classList.remove("hidden");
      this.return_btn?.classList.add("hidden");
    }
  }
}

customElements.define("drawer-menu", DrawerMenu);
